import { create } from 'zustand';

export type ChatMessage = {
  role: 'user' | 'assistant';
  content: string;
};

type AssistantStore = {
  messages: ChatMessage[];
  addMessage: (message: ChatMessage) => void;
  reset: () => void;
};

export const useAssistantStore = create<AssistantStore>((set) => ({
  messages: [],
  addMessage: (message) => set((state) => ({ messages: [...state.messages, message] })),
  reset: () => set({ messages: [] }),
}));
